module.exports = __webpack_public_path__ + "static/media/08.a678bcbd.jpg";